export default __webpack_public_path__ + "static/media/spending-accounts-icon.3b0feb20.svg";